import React, { useState } from "react";
import { format } from 'date-fns';
import { Toast, StatusTable, Row, SubmitBar, Loader } from "@egovernments/digit-ui-react-components";
import Timeline from "../components/Timeline";
import { useRouteMatch, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Tab, Tabs,styled} from "@mui/material";
import { scrutinyDetailsData } from "../utils";
import TabPanel from "./TabPanel";
import LocationDetails from "./LocationDetails";
import PlotDetails from "./PlotDetails";
import ScrutinyDetails from "./ScrutinyDetails";

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  padding: '0 1rem',
  fontSize: '18px',
}));


const BasicDetails = ({ formData, onSelect, config, currTabRoute }) => {
  const [showToast, setShowToast] = useState(null);
  const [basicData, setBasicData] = useState(formData?.data?.edcrDetails || null);
  const [scrutinyNumber, setScrutinyNumber] = useState(formData?.data?.scrutinyNumber);
  const [currentTab, setCurrentTab] = useState(currTabRoute);

  const { t } = useTranslation();
  const history = useHistory();
  const { path, params } = useRouteMatch();
  const baseUrl = path.substring(0, path.lastIndexOf('/'));
  const getPath = (path, params) => {
    params && Object.keys(params).map(key => {
      path = path.replace(`:${key}`, params[key]);
    })
    return path;
  }
  const updateTabUrl = tab => history.push(`${getPath(baseUrl, params)}/${tab}`);
  const handleTabChange = (e, newValue) => {
    setCurrentTab(newValue);
    updateTabUrl(newValue)
  }
  const stateCode = Digit.ULBService.getStateId();
  const { isMdmsLoading, data: mdmsData } = Digit.Hooks.obps.useMDMS(stateCode, "BPA", ["RiskTypeComputation"]);
  const riskType = Digit.Utils.obps.calculateRiskType(mdmsData?.BPA?.RiskTypeComputation, basicData?.planDetail?.plot?.area, basicData?.planDetail?.blocks);
  const closeToast = () => {
    setShowToast(null);
  };

  const handleSubmit = async (event) => {
    await onSelect(config?.key, { scrutinyNumber, applicantName: basicData?.planDetail?.planInformation?.applicantName, occupancyType: basicData?.planDetail?.planInformation?.occupancy, applicationType: basicData?.appliactionType, serviceType: basicData?.applicationSubType,  applicationDate: basicData?.applicationDate, riskType: Digit.Utils.obps.calculateRiskType(mdmsData?.BPA?.RiskTypeComputation, basicData?.planDetail?.plot?.area, basicData?.planDetail?.blocks), edcrDetails: basicData })
  }

  const onSkip = () => onSelect();

  let disableVlaue = sessionStorage.getItem("isEDCRDisable");
  disableVlaue = JSON.parse(disableVlaue);

  const getDetails = async () => {
    const details = await scrutinyDetailsData(scrutinyNumber?.edcrNumber, stateCode);
    if (details?.type == "ERROR") {
      setShowToast({ message: details?.message });
      setBasicData(null);
    }
    if (details?.edcrNumber) {
      setBasicData(details);
      setShowToast(null);
    }
  }

  if (disableVlaue) {
    let edcrApi = sessionStorage.getItem("isEDCRAPIType");
    edcrApi = edcrApi ? JSON.parse(edcrApi) : false;
    if (!edcrApi || !basicData) {
      sessionStorage.setItem("isEDCRAPIType", JSON.stringify(true));
      getDetails();
    }
  }

  if (isMdmsLoading) return <Loader />

  return (
    <div>
      {showToast && <Toast
        error={true}
        label={t(`${showToast?.message}`)}
        onClose={closeToast}
        isDleteBtn={true}
      />
      }
      <Timeline flow="BPA" currentStep={1}/>
      <Card className="card" style={{ 
        boxShadow: 'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset', 
        margin: '1.25rem auto 2rem',
      }}>
        <Tabs value={currentTab} onChange={handleTabChange} sx={{margin:"10px"}}>
          <StyledTab label={t("Basic Details")} value="basic-details"  />
          <StyledTab label={t("Location Details")} value="location"  />
          <StyledTab label={t("Plot Details")} value="plot-details" />
          <StyledTab label={t("BPA_EDCR_DETAILS")} value="scrutiny-details" />
        </Tabs>
        <TabPanel value={currentTab} index="basic-details" sx={{p: 0}}>
          <div style={{ background: 'white',marginLeft:"13px" }}>
        <StatusTable style={{marginBottom: '2rem'}}>
          <Row className="border-none" label={t(`BPA_BASIC_DETAILS_APP_DATE_LABEL`)} text={basicData?.applicationDate ? format(new Date(basicData?.applicationDate), 'dd/MM/yyyy') : basicData?.applicationDate} />
          <Row className="border-none" label={t(`BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL`)} text={basicData ? t(`WF_BPA_${basicData?.appliactionType}`) : ''}/>
          <Row className="border-none" label={t(`BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL`)} text={t(basicData?.applicationSubType)} />
          <Row className="border-none" label={t(`BPA_BASIC_DETAILS_OCCUPANCY_LABEL`)} text={basicData?.planDetail?.planInformation?.occupancy}/>
          <Row className="border-none" label={t(`BPA_BASIC_DETAILS_RISK_TYPE_LABEL`)} text={basicData ? t(`WF_BPA_${riskType}`) : ''} />
          <Row className="border-none" label={t(`BPA_BASIC_DETAILS_APPLICATION_NAME_LABEL`)} text={basicData?.planDetail?.planInformation?.applicantName} />
        </StatusTable>

        {riskType ? <SubmitBar label={t(`CS_COMMON_NEXT`)} onSubmit={handleSubmit} disabled={!scrutinyNumber?.edcrNumber?.length}/> : <Loader/>}
          </div>
        </TabPanel>
        <TabPanel value={currentTab} index="location" sx={{p: 0}}>
          <LocationDetails {...{ formData, onSelect, config }} />
        </TabPanel>
        <TabPanel value={currentTab} index="plot-details" sx={{p: 0}}>
          <PlotDetails {...{ formData, onSelect, config }} />
        </TabPanel>
        <TabPanel value={currentTab} index="scrutiny-details" sx={{p: 0}}>
          <ScrutinyDetails {...{formData, onSelect, config}} />
        </TabPanel>
      </Card>
    </div>
  )
}

export default BasicDetails;